import {
  Box,
  Button,
  Container,
  Typography,
  useTheme,
  Paper,
} from "@mui/material";
import React from "react";
import { ToastContainer, toast } from 'react-toastify';
import copy from "./../assets/clipboard.svg";
import { getUTCTime } from "../helper/helper";

const RedeemHistoryCard = ({
  id,
  redeemStatus,
  giftCardCode,
  creationDate,
  statusOfGiftCard,
  amount,
  onClick
}) => {
  const theme = useTheme();

  const handleClick = (id) => {
    if (onClick) {
      onClick(id);
    }
  };

  const notifyCopiedCode = () => toast.success("Referral code copied!");
  const notifyResendGC = () => toast.success("GC Sent via Email/SMS!");

  return (
    <Paper
      elevation={0}
      sx={{
        p: 2,
        borderRadius: 2,
        my: 2,
        bgcolor: theme.palette.mode === 'dark' ? 'background.paper' : 'background.default',
        border: 1,
        borderColor: theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : theme.palette.divider,
        cursor: "default",
        transition: "all 0.2s ease-in-out",
        boxShadow: theme.palette.mode === 'dark' 
          ? '0 2px 8px rgba(0, 0, 0, 0.4)' 
          : '0 2px 8px rgba(0, 0, 0, 0.08)',
        "&:hover": {
          boxShadow: theme.palette.mode === 'dark' 
            ? '0 6px 16px rgba(0, 0, 0, 0.5)' 
            : '0 6px 16px rgba(0, 0, 0, 0.12)',
          borderColor: theme.palette.mode === 'dark' 
            ? theme.palette.custom.mint 
            : theme.palette.brand.main,
          transform: 'translateY(-2px)',
        },
      }}
    >
      <Box>
        <Container
          sx={{
            display: "flex",
            justifyContent: "space-between",
            paddingLeft: 0,
            alignItems: "center",
            mb: 1.5,
          }}
        >
          <Typography variant="body1" fontWeight={500}>
            Redeem status:
          </Typography>
          <Typography 
            color={theme.palette.mode === 'dark' ? 'text.secondary' : 'text.primary'} 
            variant="body1" 
            fontWeight={500}
          >
            {redeemStatus}
          </Typography>
        </Container>

        <Container
          sx={{
            display: "flex",
            justifyContent: "space-between",
            paddingLeft: 0,
            alignItems: "center",
            mb: 1,
          }}
        >
          <Typography variant="body2">
            Gift card code:
          </Typography>
          <Box
            gap={1}
            sx={{
              display: giftCardCode ? "flex" : "none",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography
              color={theme.palette.mode === 'dark' ? 'text.secondary' : 'text.primary'}
              variant="body2"
              sx={{ fontFamily: 'monospace' }}
            >
              {giftCardCode}
            </Typography>
            <Box
              component="img"
              src={copy}
              alt="Copy"
              sx={{
                height: 14,
                cursor: 'pointer',
                opacity: theme.palette.mode === 'dark' ? 0.7 : 1,
                transition: 'opacity 0.2s',
                '&:hover': {
                  opacity: 1
                }
              }}
              onClick={() => {
                navigator.clipboard.writeText(giftCardCode);
                notifyCopiedCode();
              }}
            />
          </Box>
        </Container>

        <Container
          sx={{
            display: "flex",
            justifyContent: "space-between",
            paddingLeft: 0,
            alignItems: "center",
            mb: 1,
          }}
        >
          <Typography variant="body2">
            Gift card creation:
          </Typography>
          <Typography 
            color={theme.palette.mode === 'dark' ? 'text.secondary' : 'text.primary'} 
            variant="body2"
          >
            {getUTCTime(creationDate)}
          </Typography>
        </Container>

        <Container
          sx={{
            display: "flex",
            justifyContent: "space-between",
            paddingLeft: 0,
            alignItems: "center",
            mb: 1,
          }}
        >
          <Typography variant="body2">
            Status of gift card:
          </Typography>
          <Typography 
            color={theme.palette.mode === 'dark' ? 'text.secondary' : 'text.primary'} 
            variant="body2"
          >
            {statusOfGiftCard}
          </Typography>
        </Container>

        <Container
          sx={{
            display: "flex",
            justifyContent: "space-between",
            paddingLeft: 0,
            alignItems: "center",
          }}
        >
          <Typography variant="body2">
            Amount:
          </Typography>
          <Typography 
            color={theme.palette.mode === 'dark' ? theme.palette.custom.mint : theme.palette.brand.main}
            variant="body2"
            fontWeight={500}
          >
            ${amount}
          </Typography>
        </Container>
      </Box>
      {giftCardCode && (
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            mt: 2,
          }}
        >
          <Button
            variant="outlined"
            onClick={() => {
              handleClick(id);
              notifyResendGC();
            }}
            sx={{
              color: theme.palette.mode === 'dark' ? theme.palette.custom.mint : theme.palette.brand.main,
              borderColor: theme.palette.mode === 'dark' ? theme.palette.custom.mint : theme.palette.brand.main,
              '&:hover': {
                borderColor: theme.palette.mode === 'dark' ? theme.palette.custom.mint : theme.palette.brand.dark,
                backgroundColor: theme.palette.mode === 'dark' ? 'rgba(119, 228, 200, 0.08)' : 'rgba(21, 173, 135, 0.08)'
              }
            }}
          >
            Resend gift card code
          </Button>
        </Box>
      )}
      <ToastContainer hideProgressBar position="top-center" />
    </Paper>
  );
};

export default RedeemHistoryCard;
